var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 32 32",
    height: 512,
    viewBox: "0 0 32 32",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 8.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.7 11.3c-.4-.4-1-.4-1.4 0l-5.3 5.3-2.3-2.3c-.4-.4-1-.4-1.4 0l-1.3 1.3v6.4h5.8s.1-.1.1-.1l8.2-8.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4 23v-18c0-.5.5-1 1-1h18c.5 0 1 .5 1 1v5.5c.6-.2 1.3-.4 2-.4v-5.1c0-1.7-1.3-3-3-3h-18c-1.7 0-3 1.3-3 3v18c0 1.7 1.3 3 3 3h5.5l.4-2h-5.9c-.6 0-1-.4-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.9 13.1c-1.5-1.5-3.9-1.5-5.4 0l-.5.5 5.4 5.4.5-.5c1.5-1.5 1.5-3.9 0-5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.3 23.3c-.1.1-.2.3-.3.5l-1 5c-.1.3 0 .7.3.9.2.2.6.3.9.3l5-1c.2 0 .4-.1.5-.3l8.3-8.3-5.4-5.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPhoto);
export default __webpack_public_path__ + "static/media/edit_photo.19de327ff2f7f944b631b3b82057d0ca.svg";
export { ForwardRef as ReactComponent };